var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypeScript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 94,
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007acc",
    d: "M53 47V17h60v60H53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.155 47.105v2.445h7.8v22.2H79.5v-22.2h7.8v-2.4l-.06-2.475c0-.045-4.755-.06-10.53-.06l-10.5.045v2.46l-.045-.015zM101.2 44.6a7.26 7.26 0 0 1 3.75 2.145c.555.6 1.38 1.65 1.44 1.92 0 .1-2.595 1.845-4.17 2.82-.06.045-.3-.2-.54-.6-.78-1.1-1.575-1.6-2.82-1.68-1.8-.12-3 .825-3 2.4 0 .48.1.75.27 1.14.405.825 1.155 1.32 3.48 2.34 4.3 1.845 6.15 3.06 7.275 4.8 1.275 1.95 1.56 5 .705 7.305-.96 2.505-3.3 4.2-6.645 4.755-1.05.18-3.45.15-4.575-.045-2.4-.45-4.695-1.65-6.105-3.195-.555-.6-1.62-2.205-1.56-2.3l.57-.36 2.25-1.305 1.695-1 .4.525c.495.78 1.605 1.83 2.25 2.2 1.95 1.005 4.56.87 5.85-.3.555-.5.795-1.05.795-1.8a2.31 2.31 0 0 0-.45-1.53c-.48-.66-1.44-1.2-4.14-2.4-3.105-1.32-4.425-2.16-5.655-3.45-.705-.78-1.35-1.995-1.65-3-.225-.87-.3-3-.1-3.855.645-3 2.9-5.1 6.15-5.7 1.05-.2 3.525-.12 4.56.15l-.03.03z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeScript);
export default __webpack_public_path__ + "static/media/TypeScript.2fa920d26eedb0ba7566e86aafed1921.svg";
export { ForwardRef as ReactComponent };